<template>
  <div class="store">
    <Header></Header>
    <Nav type="6" @getStoreChildren='getStoreChildren'></Nav>
    <Toptitle title="驿活动"></Toptitle>
    <div class="activitiesCommunity_nav exhibition_nav">
      <div class="exhibition_nav_left">
        <router-link tag="a" to="/activitiesCommunity">活动社区</router-link>
        <router-link tag="a" to="/exhibition">作品展示</router-link>
        <router-link tag="a" to="/store" class="selection">驿道商店</router-link>
      </div>
      <div class="exhibition_nav_right">
        <div v-for="(item,index) of storeTypeData" :key='index' class="exhibition_item_type">
          <span :class="tip==index?'selection':''" @click="pageNo=1,getStore(item.value,index),type=item.value,index=index">{{item.key}}</span>
          <i v-show="index<2"></i>
        </div>
      </div>
    </div>
    <div class="exhibition_list store_list">
      <div class="exhibition_item" v-for="(item,index) of storeList" :key="index" @click="goArticleDetail(item.id)">
        <div class="exhibition_item_img">
          <img :src="item.picture" />
        </div>
        <div class="exhibition_item_text">
          <p>{{item.title}}</p>
        </div>
      </div>
    </div>
    <el-pagination background small layout="prev, pager, next" @current-change="handleCurrentChange" :page-size='pageSize'
      :total="totalRecord" class="newspage showInPc" :current-page="pageNo" prev-text='< 上一页' next-text='下一页 >'></el-pagination>
    <el-pagination background small layout="prev, pager, next" @current-change="handleCurrentChange" :page-size='pageSize'
      :total="totalRecord" class="newspage showInPhone" :current-page="pageNo" prev-text='<' next-text='>'></el-pagination>
    <Footer></Footer>
  </div>
</template>

<script>
  import Header from './common/Header.vue'
  import Nav from './common/Nav.vue'
  import Footer from './common/Footer.vue'
  import Toptitle from './common/Toptitle.vue'
  export default {
    data() {
      return {
        navID: '',
        tip: 0,
        storeList: [],
        pageNo: 1,
        pageSize: 10,
        type: 14,
        index: 0,
        totalRecord: 0,
        storeTypeData: [],
        value: ''
      }
    },
    components: {
      Header,
      Footer,
      Nav,
      Toptitle
    },
    computed: {

    },
    methods: {
      getStore(type, index) {
        this.tip = index
        this.axios.post('api/c_article/getListByNavIdAndTypeId.do', this.qs({
          navigateid: this.navID,
          typeid: type,
          pageNo: this.pageNo,
          pageSize: this.pageSize
        })).then(res => {
          if (res.status == 200) {
            this.pageNo = res.data.pageNo
            this.totalRecord = res.data.totalRecord
            this.storeList = res.data.results
          }
        })
      },
      getStoreChildren(data) {
        this.navID = data[1].value.id
        console.log(data)
        this.getStore(this.value, 0)
        this.getStoreType()
      },
      handleCurrentChange(val) {
        this.pageNo = val
        this.getStore(this.type, this.index)
      },
      goArticleDetail(id) {
        this.$router.push({
          name: 'articleDetail',
          query: {
            id: id
          }
        })
      },
      getStoreType() {
        this.axios.post('api/index/getNavigateDetail.do', this.qs({
          navigateid: this.navID
        })).then(res => {
          if (res.data.resultCode == 0) {
            this.storeTypeData = res.data.data
            this.value = res.data.data[0].value
          }
        })
      }
    },
    mounted() {
      // if(sessionStorage.getItem('active')){
      //   this.navID = JSON.parse(sessionStorage.getItem('active'))[1].value.id
      //   this.getStore(14,0)
      //   console.log(this.tip)
      // }
    }
  }
</script>

<style>
</style>
